var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zm-4.183 3C8.6 3 7.27 4.186 6.277 5.75h-2.24c-.35 0-.763.255-.92.569L2.053 8.442a.516.516 0 0 0 .462.746h2.23l-.483.482a.7.7 0 0 0 0 .972l1.094 1.094a.7.7 0 0 0 .973 0l.482-.483v2.231a.516.516 0 0 0 .746.462l2.121-1.061c.315-.157.57-.57.57-.921V9.72c1.56-.995 2.75-2.329 2.75-4.535.003-.541.003-1.083-.147-1.775a.371.371 0 0 0-.262-.262C11.898 3 11.357 3 10.817 3zm-.566 1.89a.86.86 0 1 1 0 1.72.86.86 0 0 1 0-1.72z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentRelease);
export default __webpack_public_path__ + "static/media/incident-release.57e09b8a2891574948443f206400bf8d.svg";
export { ForwardRef as ReactComponent };